import { useLocation, Navigate, Outlet } from "react-router-dom"
import { useState, useEffect } from "react";
import useAuth from "../hooks/useAuth"
import config from "../common/Config";

const RequireAuth = () => {
	const [isLoading, setIsLoading] = useState(true);

	const { auth, setAuth } = useAuth();
	const location = useLocation();

	useEffect(() => {

		const verifyRefresh = async () => { 
			let options = {
				credentials: 'include',
			}
		
			await fetch(config.apiUrl +'/refresh', options)
			.then(data => data.json())
			.then(data => {
				setAuth({
					userId			: data.userId,
					user			: data.user,
					accessToken 	: data.accessToken
				})
				setIsLoading(false)
			})
			.catch((e) => setIsLoading(false))
		}
		
		!auth.accessToken ? verifyRefresh() : setIsLoading(false);
	}, [])

	return (
		isLoading 
			? <p>Loading...</p>
			: auth?.accessToken 
				? <Outlet/>
				: <Navigate to="/login" state={{ from: location}} replace />
	)
}

export default RequireAuth